import { useEffect, useRef } from 'react';

interface OrderTypeConflictModalProps {
  isOpen: boolean;
  currentOrderType: string;
  newOrderType: string;
  onConfirm: () => void;
  onCancel: () => void;
}

const getOrderTypeText = (type: string) => {
  switch (type) {
    case 'DEADLINE_DISCOUNT':
      return '마감할인';
    case 'RESERVATION_DISCOUNT':
      return '예약할인';
    case 'REGULAR_ORDER':
      return '일반주문';
    default:
      return type;
  }
};

export function OrderTypeConflictModal({
  isOpen,
  currentOrderType,
  newOrderType,
  onConfirm,
  onCancel,
}: OrderTypeConflictModalProps) {
  const dialogRef = useRef<HTMLDialogElement>(null);

  useEffect(() => {
    const dialog = dialogRef.current;
    if (!dialog) return;

    if (isOpen) {
      dialog.showModal();
    } else {
      dialog.close();
    }
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <dialog
      ref={dialogRef}
      className="backdrop:bg-black backdrop:bg-opacity-50 bg-transparent border-0 p-0 m-0 max-w-none max-h-none w-full h-full"
      onClick={(e) => {
        if (e.target === e.currentTarget) {
          onCancel();
        }
      }}
    >
      <div className="flex items-center justify-center min-h-full p-4">
        <div className="bg-white rounded-xl p-6 max-w-sm w-full text-center">
        <div className="mb-4">
          <div className="w-16 h-16 mx-auto mb-4 bg-orange-100 rounded-full flex items-center justify-center">
            <svg width="32" height="32" viewBox="0 0 24 24" fill="none">
              <path
                d="M12 9V13M12 17H12.01M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
                stroke="#FF6B35"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
          <h3 className="text-lg font-semibold text-gray-900 mb-2">
            주문 유형 변경
          </h3>
          <p className="text-gray-600 text-sm leading-relaxed">
            현재 장바구니에 <span className="font-medium text-gray-900">{getOrderTypeText(currentOrderType)}</span> 상품이 있습니다.
          </p>
          <p className="text-gray-600 text-sm leading-relaxed mt-1">
            <span className="font-medium text-gray-900">{getOrderTypeText(newOrderType)}</span> 상품을 담으려면 기존 상품을 삭제해야 합니다.
          </p>
        </div>

        <div className="flex gap-3">
          <button
            onClick={onCancel}
            className="flex-1 px-4 py-3 bg-gray-100 text-gray-700 rounded-lg font-medium hover:bg-gray-200 transition-colors"
          >
            취소
          </button>
          <button
            onClick={onConfirm}
            className="flex-1 px-4 py-3 bg-red-500 text-white rounded-lg font-medium hover:bg-red-600 transition-colors"
          >
            삭제 후 담기
          </button>
        </div>
        </div>
      </div>
    </dialog>
  );
}